import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(7),
        justifyContent: "space-between",
        gap: theme.spacing(2),
    },
    cardHeader: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    changeLog: {
        marginLeft: theme.spacing(2),
    },
    tableHeaders: {
        fontWeight: "bold",
    },
    noImagesBox: {
        display: "flex",
        flex: 1,
        marginTop: theme.spacing(9),
        justifyContent: "center",
    },
    flexContainer: {
        display: "flex",
        flexGrow: 1,
    },
    logsContainer: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        backgroundColor: theme.palette.emteria.background.paper,
        padding: theme.spacing(0, 1),
    },
}));
